import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import ConstantInput from '../Input/constantInput/constantInput';

const INITIAL_FILTER = {
  searchKey: '',
};

const VendorListingFilter = ({ applyFilter, listFilterData }) => {
  const appliedValues = listFilterData?.appliedFilterValues;
  const [filterFieldsData, setFilterFieldsData] = useState(INITIAL_FILTER);

  useEffect(() => {
    if (appliedValues) {
      setFilterFieldsData({
        searchKey: appliedValues.searchKey ?? '',
      });
    } else {
      setFilterFieldsData(INITIAL_FILTER);
    }
  }, [appliedValues?.searchKey]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label="Vendor / Firm Name"
        type="text"
        placeholder="Search by vendor or firm name"
        value={filterFieldsData.searchKey}
        handleChange={(value) =>
          setFilterFieldsData((prev) => ({
            ...prev,
            searchKey: value?.trim?.() ?? value ?? '',
          }))
        }
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(INITIAL_FILTER);
            applyFilter(INITIAL_FILTER);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

VendorListingFilter.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  listFilterData: PropTypes.shape({
    appliedFilterValues: PropTypes.shape({
      searchKey: PropTypes.string,
    }),
  }),
};

VendorListingFilter.defaultProps = {
  listFilterData: null,
};

export default VendorListingFilter;
